import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/opt/build/repo/node_modules/gatsby-theme-docz/src/base/Layout.js";
import { Image, Table, Row, Attributes, Expander } from './components';
import { InfoIcon } from './components/Icons';
export const defaultFileTagsTable = [{
  param: 'Tax Returns',
  value: 'preparerfilecopy.taxreturn.tags.accounting.smartvault.com'
}, {
  param: 'Tax Returns',
  value: 'preparerreviewcopy.taxreturn.tags.accounting.smartvault.com'
}, {
  param: 'Miscellaneous',
  value: 'misc.tags.core.smartvault.com'
}, {
  param: 'Tax Returns',
  value: 'complete.taxreturn.tags.accounting.smartvault.com'
}];
export const replaceValuesTable = [{
  param: 'Fail = 0',
  value: 'Throws FileAlreadyExistsException, prompts the user to choose another name.'
}, {
  param: 'Replace = 1',
  value: 'Replaces the existing file with the new file; name remains unchanged.'
}, {
  param: 'Autocorrect = 2',
  value: 'Appends (1) to the file name if a file with the same name exists.'
}];
export const endpoints = [{
  param: 'POST',
  value: '/nodes/engagement-document'
}];
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  defaultFileTagsTable,
  replaceValuesTable,
  endpoints,
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <h1 {...{
      "id": "composite-endpoints"
    }}>{`Composite Endpoints`}</h1>
    <h2 {...{
      "id": "document-routing"
    }}>{`Document Routing`}</h2>
    <h3 {...{
      "id": "overview"
    }}>{`Overview`}</h3>
    <hr style={{
      "width": "50%"
    }} />
    <p>{`This composite endpoint simplifies the process of managing client, engagement, and document information.
It abstracts away the complexities of handling Firm, Client, and Engagement identifiers, returning an upload URI for document routing.`}</p>
    <br />
    <br />
    <h3 {...{
      "id": "key-features"
    }}>{`Key Features:`}</h3>
    <hr style={{
      "width": "50%"
    }} />
    <ul>
      <li parentName="ul">{`Simplified Upsert: Upsert (update/insert) client, engagement, and document data.`}</li>
      <li parentName="ul">{`Reduce Complexity: No need for the developer to manage or track multiple entities.`}</li>
      <li parentName="ul">{`File Upload: Returns a URI for file upload and routing to the correct folder.`}<br />
        <br /></li>
    </ul>
    <h3 {...{
      "id": "request-body-structure"
    }}>{`Request Body Structure`}</h3>
    <hr style={{
      "width": "50%"
    }} />
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`{
    "accountId": "OrganizationalUnitId",
    "Client": {...},     // Client Object            
    "engagement": {...}, // Engagement Object
    "fileTag": "Folder tag to route the document",
    "uploadFileRequest": {
        "name": "2022_12345678910_Deer, Mary Sue_PreparerCopyK1Package.txt",
        "replace": 0,  // Replace options {0, 1, 2}
        "description": "Preparer Copy - Printed by My Awesome apps!!"
    },
    "uploadVersionData": {
        "length": 1405,  // Length of the file in bytes
        "md5_checksum": "D/pj1png88JDuzHAZ8xoEA==" // Base64 endcoded string
    }
}
`}</code></pre>
    <h3 {...{
      "id": "why-use-this-endpoint"
    }}>{`Why use this endpoint?`}</h3>
    <hr style={{
      "width": "50%"
    }} />
    <p>{`This composite endpoint allows developers to quickly create needed entities for proper file routing without the need to manage clients, engagements, and documents separately, enabling faster integration.`}</p>
    <br />
    <br />
    <br />
    <br />
    <hr style={{
      "width": "100%"
    }} />
    <br />
    <br />
    <br />
    <h2 {...{
      "id": "upserting-a-client"
    }}>{`Upserting a Client`}</h2>
    <hr style={{
      "width": "50%"
    }} />
    <p>{`At the core of SmartVault is the client entity.
Each client has an associated vault where their folders and files are stored.
Before routing any document, ensure the client is created and mapped to your application’s client.`}</p>
    <br />
    <InfoIcon mdxType="InfoIcon" />In order to properly map a SmartVault client to your application, you must have an identifier and provide that as an Alias when creating the client.
    <br />
    <InfoIcon mdxType="InfoIcon" />A SmartVault client should map one-to-one with a client in your application.
    <br />
    <br />
Example: Client Alias
    <br />
These properties are defined by your application and must be unique for each client.
    <br />
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`{
    "Domain": "awesome-app.com",  // Alphanumerical
    "Type": "identifier",         // Alphanumerical
    "Value": "12345678911"        // Alphanumerical
}
`}</code></pre>
    <h3 {...{
      "id": "client-types"
    }}>{`Client Types`}</h3>
    <hr style={{
      "width": "50%"
    }} />
    <p>{`SmartVault supports two main types of clients:`}</p>
    <br />
1. Organization
    <br />
2. Persons
    <br />
Each type has subtypes. For more details, refer to the <a href="/api/entities/clients#retrieve-type-qualifiers" target="_blank">
	SmartVault Client API documentation
    </a>.
    <br />
    <br />
    <p><strong parentName="p">{`Example: Individual Client`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`{
    "persons": [{
        "names": [{
            "FirstName": "Mary",
            "MiddleName": "Sue",
            "LastName": "Deer"
        }],
        "phone_numbers": [{
            "Number": "123-456-7890"
        }],
        "email_addresses": [{
            "address": "mDeer1@email.com"
        }]
    }],
    "aliases": [{
        "Domain": "awesome-app.com",
        "Type": "identifier",
        "Value": "12345678910"
    }],
    "type_qualifier": "Individual"
}
`}</code></pre>
    <p><strong parentName="p">{`Example: Corporate Client`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`{
    "organization": {
        "names": [{
            "name": "Tax Man LLC"
        }],
        "email_addresses": [{
            "address": "taxmanllc@taxman.com"
        }],
        "phone_numbers": [{
            "Number": "+1123456789"
        }]
    },
    "aliases": [{
        "Domain": "awesome-app.com",
        "Type": "identifier",
        "Value": "9873902-Ajdl-21898"
    }],
    "end_of_fiscal_year": 12,
    "type_qualifier": "Corporate"
}
`}</code></pre>
    <br />
    <InfoIcon mdxType="InfoIcon" />For more information on client creation, please review the full documentation <a href="/api/entities/clients#create-a-client" target="_blank">
	here
    </a>.
    <br />
    <br />
    <br />
    <br />
    <hr style={{
      "width": "100%"
    }} />
    <br />
    <br />
    <br />
    <h2 {...{
      "id": "the-engagement-object"
    }}>{`The Engagement Object`}</h2>
    <hr style={{
      "width": "50%"
    }} />
    <p>{`The Engagement Object is used to create the folder structure for a file.
It performs an upsert operation, creating the engagement if it doesn’t already exist.`}</p>
    <br />
    <p><strong parentName="p">{`Example: Engagement Object`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`{
    "entity": {
        "meta_data": {
            "entity_definition": "The engagement type"
        },
        "smart_vault": {
            "accounting": {
                "engagement": {
                    "period": "The year/month/period for this engagement."
                }
            }
        }
    }
}
`}</code></pre>
    <br />
    <InfoIcon mdxType="InfoIcon" />For default values of structured accounts, refer to the <a href="/api/entities/engagements/#engagement-types" target="_blank">
	Engagement Types documentation
    </a>.
    <br />
    <br />
    <br />
    <br />
    <hr style={{
      "width": "100%"
    }} />
    <br />
    <br />
    <br />
    <h2 {...{
      "id": "file-tags"
    }}>{`File Tags`}</h2>
    <hr style={{
      "width": "50%"
    }} />
    <p>{`File tags are used to route documents to the appropriate folder within SmartVault.`}</p>
    <br />
    <InfoIcon mdxType="InfoIcon" />Tags can be added or removed, and if a tag is not found, the document is uploaded to the "miscellaneous" folder. 
If the miscellaneous folder does not exist, the file will not be routed, and an error will be returned. 
Ensure your application can handle this scenario.
    <br />
    <br />

    <Table data="info" title="Default File Tags" rows={defaultFileTagsTable} mdxType="Table" />
    <br />
    <br />
    <br />
    <br />
    <hr style={{
      "width": "100%"
    }} />
    <br />
    <br />
    <br />
    <h3 {...{
      "id": "file-objects"
    }}>{`File Objects`}</h3>
    <hr style={{
      "width": "50%"
    }} />
    <p>{`The SmartVault system utilizes File and Version objects for document uploads.
Below are the necessary attributes:`}</p>
    <br />
    <p><strong parentName="p">{`Example: File and Version Object`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`"uploadFileRequest": {
    "name": "test_file_name.txt",
    "replace": 1  // 0=Fail, 1=Replace, 2=Autocorrect
},
"uploadVersionData": {
    "length": 1405,
    "md5_checksum": "D/pj1png88JDuzHAZ8xoEA=="
}
`}</code></pre>

    <Table data="info" title="Replace Values" rows={replaceValuesTable} mdxType="Table" />
    <br />
    <br />
    <br />
    <br />
    <hr style={{
      "width": "100%"
    }} />
    <br />
    <br />
    <br />
    <h2 {...{
      "id": "engagement-document"
    }}>{`Engagement-document`}</h2>
    <hr style={{
      "width": "50%"
    }} />

    <p>{`Construct the Client object that the document belongs to.
Client should map one-to-one with an identity on your application.`}</p>
    <Table title="endpoints" rows={endpoints} mdxType="Table" />
    <br />
    <br />
    <br />
    <Expander title="Body Parameters" mdxType="Expander">
	<Attributes items={[{
        name: 'account_id',
        type: 'string',
        description: 'Required. The account\'s alphanumerical identification.'
      }, {
        name: 'client',
        type: 'object',
        description: 'Optional. Client object to be created/updated must include alias. If SmartVault clientId is known, you can omit Client and pass the client id using client_id body.'
      }, {
        name: 'engagement',
        type: 'object',
        description: 'Required. SmartVault equivalent name for the engagement type.'
      }, {
        name: 'fileTag',
        type: 'string',
        description: 'Optional. Tag used for routing the document within the clients folder structure. fileTag will not be used if document_properties are set on the uploadFileRequest.'
      }, {
        name: 'uploadFileRequest',
        type: 'object',
        description: 'Required.'
      }, {
        name: 'name',
        type: 'string',
        description: 'Required. The name of the file.'
      }, {
        name: 'replace',
        type: 'number',
        description: 'Required.'
      }, {
        name: 'description',
        type: 'string',
        description: 'Optional.'
      }, {
        name: 'uploadVersionData',
        type: 'object',
        description: 'Required.'
      }]} mdxType="Attributes" />
	<br />
	<h4>Upload information for your file.</h4>
	<hr />
	<Attributes items={[{
        name: 'length',
        type: 'number',
        description: 'Required. File size in bytes. Will be different than original_length if it\'s been compressed.'
      }, {
        name: 'md5_checksum',
        type: 'string',
        description: 'Optional. The server generates one automatically if it hasn\'t been specified.',
        values: ['Must be in base64']
      }]} mdxType="Attributes" />
    </Expander>
    <br />
    <br />
    <br />
    <p><strong parentName="p">{`Example: Engagement document`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`{
    "accountId": "{{smartvault_account_id}}",
    "client": {
        "persons": [{
            "names": [{
                "FirstName": "Mary",
                "MiddleName": "Sue",
                "LastName": "Deer"
            }],
            "phone_numbers": [{
                "Number": "123-456-7890"
            }],
            "email_addresses": [{
                "address": "mDeer1@email.com"
            }]
        }],
        "aliases": [{
            "Domain": "awesome-app.com",
            "Type": "identifier",
            "Value": "12345678910"
        }],
        "type_qualifier": "Individual"
    },
    "engagement": {
        "entity": {
            "meta_data": {
                "entity_definition": "SmartVault.Accounting.TaxEngagement"
            },
            "smart_vault": {
                "accounting": {
                    "engagement": {
                        "period": "2024"
                    }
                }
            }
        }
    },
    "fileTag": "preparerfilecopy.taxreturn.tags.accounting.smartvault.com",
    "uploadFileRequest": {
        "name": "2022_12345678910_Deer, Mary Sue_PreparerCopyK1Package.txt",
        "replace": 1, 
        "description": "Preparer Copy - Printed by My Awesome apps!!"
    },
    "uploadVersionData":{
        "length": 1405,
        "md5_checksum": "D-pj1png88JDuzHAZ8xoEA=="
    }
}
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      